export default {
    topic: state => state.topic,
    item: state => state.item,
    items: state => state.items,
    clickedReferences: state => state.clickedReferences,
    itemContent: state => state.itemContent,
    clinicalHandouts: state => state.clinicalHandouts,
    conversations: state => state.conversations,
    conversation: state => state.conversation,
    conversationsNextCursor: state => state.conversationsNextCursor,
};